import { FooterType } from 'common/api/query/bailleurs-configuration/footer.query';
import React from 'react';
import { FooterElementContainer } from './footer-element';
export const FooterContainer = props => {
    const [metionsVisible, setMentionsVisible] = React.useState(false);
    const [helpVisible, setHelpVisible] = React.useState(false);
    const [confidentialVisible, setConfidentialVisible] = React.useState(false);
    const lineRender = (visible) => {
        return visible &&
            React.createElement("li", { className: 'list-inline-item me-xl-2 w-auto mb-0 align-items-center d-flex font-size-10' },
                React.createElement("span", null, "|"));
    };
    return (React.createElement("footer", { className: 'footer bg-white d-flex align-items-center mt-auto' },
        React.createElement("div", { className: 'container' },
            React.createElement("ul", { className: 'list-inline-md text-md-center mb-0 d-flex justify-content-center align-items-center' },
                React.createElement(FooterElementContainer, { footerType: FooterType.LEGAL_MENTIONS, visibleSetter: setMentionsVisible }),
                lineRender(metionsVisible && helpVisible),
                React.createElement(FooterElementContainer, { footerType: FooterType.HELP, visibleSetter: setHelpVisible }),
                lineRender(helpVisible && confidentialVisible),
                React.createElement(FooterElementContainer, { footerType: FooterType.CONFIDENTIAL, visibleSetter: setConfidentialVisible })))));
};
